import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const RequirementsSectionLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-requirementssection" */ "./RequirementsSection")).then((bundle)=>{
        return {
            default: bundle.RequirementsSection
        };
    });
export const LazyRequirementsSection = /*#__PURE__*/ lazy(RequirementsSectionLazyLoader);
